(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubble-floating-video"] && !Shopify.designMode) return;
  try {
    
  class BubbleFloatingVideo extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.preview = this.querySelector('.bubble-floating-video__preview');
      this.launch = this.querySelector('.bubble-floating-video__launch');
      this.teaser = this.launch.querySelector('video');
      this.dialog = this.querySelector('dialog');
      this.player = this.dialog.querySelector('video');
      this.launch.addEventListener('click', () => this.openVideo(), options);
      this.querySelector('.bubble-floating-video__dismiss').addEventListener('click', () => {
        this.preview.hidden = true;
        this.teaser.pause();
      }, options);
      this.querySelector('.bubble-floating-video__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        const rect = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.player.pause();
        document.documentElement.style.overflow = this.previousOverflow;
        this.launch.focus({ preventScroll: true });
        this.playPreview();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.teaser.pause();
          this.player.pause();
        } else if (!this.dialog.open) this.playPreview();
      }, options);
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) this.playPreview();
        else this.teaser.pause();
      });
      this.observer.observe(this.preview);
    }
    playPreview() {
      if (this.preview.hidden || document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.teaser.muted = true;
      if (!this.teaser.getAttribute('src')) this.teaser.src = this.teaser.dataset.src;
      this.teaser.play().catch(() => {});
    }
    openVideo() {
      this.teaser.pause();
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (!this.player.getAttribute('src')) this.player.src = this.player.dataset.src;
      this.player.play().catch(() => {});
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
      this.events = null;
      this.teaser?.pause();
      this.player?.pause();
      if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow;
    }
  }
  if (!customElements.get('bubble-floating-video')) customElements.define('bubble-floating-video', BubbleFloatingVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubble-video-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('.bubble-video-play');
  if (!button) return;
  const video = button.closest('.bubble-video-card').querySelector('video');
  video.play().catch(function() { button.hidden = false; });
});
document.addEventListener('play', function(event) {
  const video = event.target;
  const card = video.closest && video.closest('.bubble-video-card');
  if (!card) return;
  card.querySelector('.bubble-video-play').hidden = true;
  card.closest('.bubble-video-section').querySelectorAll('video').forEach(function(other) {
    if (other !== video) other.pause();
  });
}, true);
document.addEventListener('pause', function(event) {
  const card = event.target.closest && event.target.closest('.bubble-video-card');
  if (card) card.querySelector('.bubble-video-play').hidden = false;
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
